/**
 * PageOB404.js
 * @author Jaiván Piña
 */

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';
import { withStyles } from '@material-ui/core/styles';

//material-ui
import Grid from '@material-ui/core/Grid';
import PlazoFijoBoton from '../common/components/PlazoFijoBoton';
import Legales from './Legales';

//Assets
import error from '../../../static/img/ya_sos_cliente_error.png';
import logoBh from '../../../static/img/logo-bh.png';
import {makeRelativeRedirect,makeAbsoluteRedirect} from "../Utils/RedirectUtils"

class ErrorYaEsCliente extends Component {

    constructor(props) {
        super(props);
        this.state = {
            style: {
                marginTop: '',
                marginBottom: ''
            },
            disabledBtn: false,
        }
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }
    
    render() {
        const {classes} = this.props;

        return (
            <div className={classes.mainContainer}>
                
                <Grid container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start">
                        <img src={logoBh} className={classes.logoBh}/>
                </Grid>

                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center"
                    className={classes.containerData}>

                    <Grid item xs={12} sm={12} style={{ marginBottom: '27px' }} >
                        <img src={error} />
                    </Grid>
                    
                    <Grid item xs={12}  style={{ marginTop: '0px' }}  container direction="column" justify="center" alignItems="center">
                        <h5 className={classes.notFound} >Ya sos cliente</h5>
                        <h6 className={classes.description}>Ingresá a tu  Homebanking para poder realizar el Plazo Fijo</h6>
                    </Grid>

                    <Grid item>
                        <PlazoFijoBoton text="ir al homebanking" doAction={ makeAbsoluteRedirect("https://hb.hipotecario.com.ar/hb/#/") }/>
                    </Grid>
                    
                </Grid>
            </div>
        );
    }
}

const styles = theme => ({
    mainContainer : {
        marginTop: "10px",
        textAlign: "center"
    },
    logoBh: {
        float: "left",
        marginTop: "27px",
        marginLeft: "27px",
    },
    containerData:{
        marginTop : "55px"
    },
    notFound: {
        width: "258px",
        height: "30px",
        fontFamily: "Roboto",
        fontSize: "26px",
        fontWeight: "bold",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color:"#606162",
        textAlign:"center",
        marginBottom: 19,
        marginTop:0
    },
    description: {
        width: "300px",
        height: "85px",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: "normal",
        fontStyle: "normal",
        fontStretch: "normal",
        lineHeight: 1.2,
        letterSpacing: "normal",
        textAlign: "center",
        color: "#929292",
        marginTop: 0,
        marginBottom: 10
    },
    //DESKTOP
    '@media  screen and (min-width: 787px)': {
        logoBh: {
            float: "left",
            marginTop: "42px",
            marginLeft: "263px"    
        },
        notFound: {
            width: "394px",
            height: "30px",
            marginBottom: 9
        },
        description:{
            width: "382px"
        }
    },
});

export default withStyles(styles)(ErrorYaEsCliente);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/error/ErrorYaEsCliente.js